<template>
  <select :value="value" v-model="selectedVehicleType" :name="name" :id="name" :class="[selectedVehicleType == '' ? 'not-selected' : '', classes, 'vehiclepicker']" @change="changeVehicleType">
    <option value="all" v-if="placeholder" selected>{{ placeholder }}</option>
    <option value="all">Todos</option>
    <option v-for="vehicleType in vehicleTypes" :value="vehicleType.slug" :key="vehicleType.id">{{ vehicleType.name }}</option>
  </select>
</template>

<script>
export default {
  name: 'TypeSelect',
  props: ['name', 'classes', 'value', 'placeholder'],
  data() {
    return {
      selectedVehicleType: '',
      vehicleTypes: []
    };
  },
  methods: {
    changeVehicleType(value) {
      this.$emit('updatevehicletype', this.selectedVehicleType);
    },
    getVehicleType() {
      new Promise((resolve, reject) => {
        this.$http.get(process.env.API_URL + 'vehicle/types')
          .then(response => {
            this.vehicleTypes = response.data;
          });
      });
    } 
  },
  mounted() {
    this.selectedVehicleType = 'all';
    this.getVehicleType();
  }
};
</script>

<style lang="scss">
.vehiclepicker {
  width: 100%;
  border: none;
  padding: 0;
  border-right: 0 !important;
  font-size: 14px !important;
  &.not-selected {
    color: #a6a5a7;
  }
}
</style>